import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import * as allActions from "./actions";

/**
 * Hook providing bound action creators for the licensingJobs Redux slice.
 * @returns {Object} Bound action creators: updateJobs, updateJobsSearchForm, updateJobsForm, clearJobs, clearJobViewModal, clearJobTasksModal
 */
export function useJobsActions() {
  const dispatch = useDispatch();
  return useMemo(() => bindActionCreators(allActions, dispatch), [dispatch]);
}
